module.exports = __webpack_public_path__ + "img/xmasParty10.e7e29af0.jpg";